import React, { useRef, useCallback } from "react";

import useOutsideClick from "../../generic/hooks/use-outside-click/use-outside-click";

const defaultFunction = () => {};
const LeftMenuHolder = ({
  isWide = false,
  onClickOutside: propsOnClickOutside,
  children,
}) => {
  const ref = useRef();
  const handler = useCallback(() => {
    if (isWide) {
      return;
    }
    const execute = propsOnClickOutside || defaultFunction;
    execute();
  }, [isWide, propsOnClickOutside]);

  useOutsideClick(ref, handler);

  return <div ref={ref}>{children}</div>;
};

export default LeftMenuHolder;
